/**
 * @generated SignedSource<<dcab927ed720001a3314613dc88b95d9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type StudentSkillAssessmentWeeklySnapshotFilterInput = {
  classIds?: ReadonlyArray<string> | null | undefined;
  gradeLevelIds?: ReadonlyArray<string> | null | undefined;
  isActive?: boolean | null | undefined;
  reportFromDate: any;
  reportToDate: any;
  siteIds?: ReadonlyArray<string> | null | undefined;
  targetGroupIds?: ReadonlyArray<string> | null | undefined;
};
export type DashboardSkillChallengeAttemptedPerStudentQuery$variables = {
  filter: StudentSkillAssessmentWeeklySnapshotFilterInput;
};
export type DashboardSkillChallengeAttemptedPerStudentQuery$data = {
  readonly studentSkillAssessmentsReport: {
    readonly nodes: ReadonlyArray<{
      readonly firstName: string;
      readonly lastName: string;
      readonly notPassedSkillChallenges: number;
      readonly passedSkillChallenges: number;
      readonly publicUserId: string;
      readonly totalSkillChallenges: number;
      readonly userId: number;
    }> | null | undefined;
  } | null | undefined;
};
export type DashboardSkillChallengeAttemptedPerStudentQuery = {
  response: DashboardSkillChallengeAttemptedPerStudentQuery$data;
  variables: DashboardSkillChallengeAttemptedPerStudentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filter"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "filter",
        "variableName": "filter"
      },
      {
        "kind": "Literal",
        "name": "first",
        "value": 10000
      }
    ],
    "concreteType": "StudentSkillAssessmentsReportConnection",
    "kind": "LinkedField",
    "name": "studentSkillAssessmentsReport",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "StudentSkillAssessmentsReport",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "userId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "publicUserId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notPassedSkillChallenges",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "passedSkillChallenges",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalSkillChallenges",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DashboardSkillChallengeAttemptedPerStudentQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DashboardSkillChallengeAttemptedPerStudentQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "0853b19975bbadfce789b5de012e860e",
    "id": null,
    "metadata": {},
    "name": "DashboardSkillChallengeAttemptedPerStudentQuery",
    "operationKind": "query",
    "text": "query DashboardSkillChallengeAttemptedPerStudentQuery(\n  $filter: StudentSkillAssessmentWeeklySnapshotFilterInput!\n) {\n  studentSkillAssessmentsReport(filter: $filter, first: 10000) {\n    nodes {\n      userId\n      firstName\n      lastName\n      publicUserId\n      notPassedSkillChallenges\n      passedSkillChallenges\n      totalSkillChallenges\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "4cbcabb9ff769c8acd384895e4ea7771";

export default node;
